import { render } from "./Revenues.vue?vue&type=template&id=1fbf39b1"
import script from "./Revenues.vue?vue&type=script&lang=js"
export * from "./Revenues.vue?vue&type=script&lang=js"

import "./Revenues.vue?vue&type=style&index=0&id=1fbf39b1&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__